import { ResetPasswordState } from '@pages/reset-password/store/state/reset-password.state';

export const resetPasswordState = [ResetPasswordState];
